import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import React, { FC } from 'react';

const useStyles = makeStyles((theme: any) => ({
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
  },
  textColumn: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  boldFont: { fontWeight: 500, overflowWrap: 'anywhere' },
  colorBlack: { color: theme.palette.text.primary },
  colorTag: {
    color: theme.palette.tab.offselected,
    overflowWrap: 'anywhere',
    marginRight: theme.spacing(2),
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));

type Tag = {
  _id: string;
  kind: string;
  description: string;
};

type ItemtagType = {
  tag: Tag;
  options: Function;
};

export const ItemTag: FC<ItemtagType> = ({ tag, options }) => {
  const tagCode = `{{${tag._id}}}`;
  const classes = useStyles();
  return (
    <div className={classes.row}>
      <div className={classes.textColumn}>
        <Typography
          variant="caption"
          className={clsx(classes.boldFont, classes.colorBlack)}
        >
          {tagCode}
        </Typography>
        <Typography
          variant="caption"
          className={clsx(classes.boldFont, classes.colorTag)}
        >
          {tag.description}
        </Typography>
      </div>
      <div className={classes.actions}>
        <div>{options()}</div>
      </div>
    </div>
  );
};
